var map = {
	"./1483527489car72.png": 63880,
	"./148974185214418789671441692979safari6.png": 80928,
	"./148974186714897416301441692987car72.png": 68102,
	"./14903316981452579453logistics3.png": 17983,
	"./14924099031441692979safari6.png": 1140,
	"./1604917175download.png": 92119,
	"./1748610867208-946935796.png": 16817,
	"./BaloonIcons/Green-east.png": 28187,
	"./BaloonIcons/Green-north-east.png": 91391,
	"./BaloonIcons/Green-north-west.png": 66101,
	"./BaloonIcons/Green-north.png": 89807,
	"./BaloonIcons/Green-south-east.png": 46079,
	"./BaloonIcons/Green-south-west.png": 56586,
	"./BaloonIcons/Green-south.png": 21480,
	"./BaloonIcons/Green-west.png": 83248,
	"./BaloonIcons/Orange-east.png": 21859,
	"./BaloonIcons/Orange-north-east.png": 85119,
	"./BaloonIcons/Orange-north-west.png": 94468,
	"./BaloonIcons/Orange-north.png": 35300,
	"./BaloonIcons/Orange-south-east.png": 73566,
	"./BaloonIcons/Orange-south-west.png": 29930,
	"./BaloonIcons/Orange-south.png": 53131,
	"./BaloonIcons/Orange-west.png": 16711,
	"./BaloonIcons/Red-east.png": 60942,
	"./BaloonIcons/Red-north-east.png": 24676,
	"./BaloonIcons/Red-north-west.png": 77118,
	"./BaloonIcons/Red-north.png": 68016,
	"./BaloonIcons/Red-south-east.png": 27744,
	"./BaloonIcons/Red-south-west.png": 27320,
	"./BaloonIcons/Red-south.png": 63357,
	"./BaloonIcons/Red-west.png": 43336,
	"./BaloonIcons/Yellow-east.png": 23227,
	"./BaloonIcons/Yellow-north-east.png": 82410,
	"./BaloonIcons/Yellow-north-west.png": 35626,
	"./BaloonIcons/Yellow-north.png": 37776,
	"./BaloonIcons/Yellow-south-east.png": 18826,
	"./BaloonIcons/Yellow-south-west.png": 8384,
	"./BaloonIcons/Yellow-south.png": 20601,
	"./BaloonIcons/Yellow-west.png": 65206,
	"./BaloonIcons/gray-east.png": 82891,
	"./BaloonIcons/gray-north-east.png": 36030,
	"./BaloonIcons/gray-north-west.png": 34984,
	"./BaloonIcons/gray-north.png": 55236,
	"./BaloonIcons/gray-south-east.png": 70821,
	"./BaloonIcons/gray-south-west.png": 97318,
	"./BaloonIcons/gray-south.png": 37980,
	"./BaloonIcons/gray-west.png": 20263,
	"./NewDesign/AI/AiIcon.png": 90809,
	"./NewDesign/AI/AifillIcon.png": 85608,
	"./NewDesign/AI/aifillsmall.png": 70953,
	"./NewDesign/Alert/exclamation-triangle-fill.png": 79994,
	"./NewDesign/Delete.png": 12989,
	"./NewDesign/DetailTracking/AlertGreen.png": 80614,
	"./NewDesign/DetailTracking/AlertRed.png": 4602,
	"./NewDesign/DetailTracking/GPSGreen.png": 23846,
	"./NewDesign/DetailTracking/GPSRed.png": 86411,
	"./NewDesign/DetailTracking/IgnitionOn.png": 72625,
	"./NewDesign/DetailTracking/IgnitionStop.png": 13439,
	"./NewDesign/DetailTracking/MapIcon.png": 87675,
	"./NewDesign/DetailTracking/PowerGreen.png": 10420,
	"./NewDesign/DetailTracking/PowerRed.png": 83926,
	"./NewDesign/DetailTracking/ShareIcon.png": 13001,
	"./NewDesign/DetailTracking/all.png": 52800,
	"./NewDesign/DetailTracking/idle.png": 36100,
	"./NewDesign/DetailTracking/no-data.png": 61428,
	"./NewDesign/DetailTracking/not-reported.png": 80365,
	"./NewDesign/DetailTracking/power-cut.png": 53221,
	"./NewDesign/DetailTracking/running.png": 13415,
	"./NewDesign/DetailTracking/stop.png": 72466,
	"./NewDesign/Emailreport/envelope-fill.png": 99269,
	"./NewDesign/Featuredicon.png": 94351,
	"./NewDesign/Graph/Vector 300 (Stroke).png": 82220,
	"./NewDesign/Graph/Vector.png": 5912,
	"./NewDesign/Graph/activity.png": 3404,
	"./NewDesign/Graph/bar-chart-fill.png": 34961,
	"./NewDesign/Graph/bar-chart-steps.png": 93840,
	"./NewDesign/Graph/fuel-pump-fill.png": 71860,
	"./NewDesign/Graph/graph-down-arrow.png": 3667,
	"./NewDesign/Graph/graph-down.png": 67762,
	"./NewDesign/Graph/graph-up-arrow.png": 58528,
	"./NewDesign/Graph/pie-chart-fill.png": 42127,
	"./NewDesign/Masters.png": 35979,
	"./NewDesign/Masters/Inventory.png": 26451,
	"./NewDesign/Masters/Payment.png": 16518,
	"./NewDesign/Masters/Subtract-1.png": 64157,
	"./NewDesign/Masters/Subtract-2.png": 28438,
	"./NewDesign/Masters/Subtract.png": 98004,
	"./NewDesign/Masters/Trip-management.png": 19294,
	"./NewDesign/Masters/Union.png": 27449,
	"./NewDesign/Masters/briefcase-fill.png": 47727,
	"./NewDesign/Masters/person-fill.png": 76135,
	"./NewDesign/Masters/warehouse.png": 65801,
	"./NewDesign/Pi7_cloud-computing.png": 93497,
	"./NewDesign/Reports/clipboard-check-fill.png": 2935,
	"./NewDesign/Reports/clipboard-data-fill.png": 50605,
	"./NewDesign/Reports/clipboard-minus-fill.png": 59866,
	"./NewDesign/Reports/clipboard-plus-fill.png": 9982,
	"./NewDesign/Reports/clipboard-x-fill-1.png": 76923,
	"./NewDesign/Reports/clipboard-x-fill.png": 25189,
	"./NewDesign/Search.png": 23288,
	"./NewDesign/Settings/bell-fill.png": 49882,
	"./NewDesign/Settings/broadcast-pin.png": 71506,
	"./NewDesign/Settings/chat-left-dots-fill.png": 90055,
	"./NewDesign/Settings/chat-text-fill.png": 3921,
	"./NewDesign/Settings/cursor-fill.png": 3062,
	"./NewDesign/Settings/envelope-fill.png": 60594,
	"./NewDesign/Settings/geo-alt-fill.png": 17084,
	"./NewDesign/Settings/phone-fill.png": 98501,
	"./NewDesign/Settings/phone-vibrate-fill.png": 98936,
	"./NewDesign/Settings/search.png": 50982,
	"./NewDesign/Settings/shield-lock-fill.png": 59016,
	"./NewDesign/Settings/sim-fill.png": 78457,
	"./NewDesign/Subtract.png": 5176,
	"./NewDesign/TicketMenu.png": 6015,
	"./NewDesign/Tickets/TicketMenu.png": 83592,
	"./NewDesign/Tracking/Union-1.png": 69020,
	"./NewDesign/Tracking/Union.png": 585,
	"./NewDesign/Tracking/bar-chart-fill.png": 33500,
	"./NewDesign/Tracking/broadcast.png": 74192,
	"./NewDesign/Tracking/camera-video-fill.png": 71214,
	"./NewDesign/Tracking/collection-play-fill.png": 60576,
	"./NewDesign/Tracking/compass-fill.png": 57985,
	"./NewDesign/Tracking/cursor-fill.png": 34442,
	"./NewDesign/Tracking/geo-alt-fill-1.png": 2688,
	"./NewDesign/Tracking/geo-alt-fill.png": 69485,
	"./NewDesign/Tracking/geo-fill.png": 88676,
	"./NewDesign/Tracking/house-door-fill.png": 48132,
	"./NewDesign/Tracking/pie-chart-fill.png": 3194,
	"./NewDesign/Tracking/pin-map-fill.png": 13846,
	"./NewDesign/Tracking/tools.png": 47148,
	"./NewDesign/Waste/bar-chart-line-fill.png": 58221,
	"./NewDesign/Waste/box-fill.png": 16456,
	"./NewDesign/Waste/briefcase-fill.png": 85746,
	"./NewDesign/Waste/clipboard-data-fill.png": 2366,
	"./NewDesign/Waste/clipboard2-check-fill.png": 49625,
	"./NewDesign/advancedashboard-fill.png": 13907,
	"./NewDesign/advancedashboard.png": 98105,
	"./NewDesign/apiGuide.png": 21411,
	"./NewDesign/back-in-time.png": 12309,
	"./NewDesign/bell.png": 97283,
	"./NewDesign/box-fill.png": 74620,
	"./NewDesign/box.png": 11392,
	"./NewDesign/check.png": 54373,
	"./NewDesign/chevron-down.png": 43624,
	"./NewDesign/chevron-right.png": 88135,
	"./NewDesign/clipboard-filll.png": 45447,
	"./NewDesign/clipboard.png": 72548,
	"./NewDesign/ctrax-inner.png": 13158,
	"./NewDesign/down-arrow.png": 28358,
	"./NewDesign/envelope-fill.png": 60689,
	"./NewDesign/envelope.png": 81643,
	"./NewDesign/exclamation-triangle-fill.png": 12759,
	"./NewDesign/exclamation-triangle.png": 28421,
	"./NewDesign/finish.png": 58295,
	"./NewDesign/gateway.png": 23613,
	"./NewDesign/gatewayDashboard.png": 94544,
	"./NewDesign/gatewayfill.png": 18619,
	"./NewDesign/gear-fill.png": 21917,
	"./NewDesign/gear.png": 50783,
	"./NewDesign/geo-fill.png": 45756,
	"./NewDesign/geo.png": 86466,
	"./NewDesign/harshAcceleration.png": 34848,
	"./NewDesign/harshAccelerationmap.png": 17438,
	"./NewDesign/harshBraking.png": 76485,
	"./NewDesign/harshBrakingmap.png": 75471,
	"./NewDesign/harshCornering.png": 87278,
	"./NewDesign/harshCorneringmap.png": 38517,
	"./NewDesign/idle.png": 91871,
	"./NewDesign/intellicab_lg.png": 48348,
	"./NewDesign/kebab.png": 55119,
	"./NewDesign/livetracking/LockIcon.png": 70634,
	"./NewDesign/livetracking/SearchIcon.png": 7681,
	"./NewDesign/livetracking/UnlockIcon.png": 68904,
	"./NewDesign/livetracking/car-trans1-1.png": 60336,
	"./NewDesign/livetracking/car-trans1green.png": 76632,
	"./NewDesign/livetracking/car-trans1grey.png": 97658,
	"./NewDesign/livetracking/car-trans1red.png": 75707,
	"./NewDesign/livetracking/geo-alt-fill.png": 5898,
	"./NewDesign/livetracking/hurricane.png": 84764,
	"./NewDesign/livetracking/image 23.png": 32539,
	"./NewDesign/livetracking/image 24.png": 22650,
	"./NewDesign/livetracking/image 25.png": 40432,
	"./NewDesign/livetracking/image 26.png": 73123,
	"./NewDesign/livetracking/map-fill.png": 97431,
	"./NewDesign/livetracking/pin-map-fill.png": 32432,
	"./NewDesign/livetracking/tag-fill.png": 63066,
	"./NewDesign/locaion-icon 2.png": 88551,
	"./NewDesign/logout.png": 67794,
	"./NewDesign/navigation-green.png": 70993,
	"./NewDesign/navigation-red.png": 32569,
	"./NewDesign/navigation-yellow.png": 26234,
	"./NewDesign/navigation.png": 90511,
	"./NewDesign/navigation2.png": 61179,
	"./NewDesign/overspeed.png": 62429,
	"./NewDesign/pause.png": 32968,
	"./NewDesign/person-fill.png": 39123,
	"./NewDesign/pie-chart-fill.png": 23045,
	"./NewDesign/pie-chart.png": 24531,
	"./NewDesign/play.png": 12261,
	"./NewDesign/plus (Stroke).png": 4570,
	"./NewDesign/running.png": 44079,
	"./NewDesign/sphere.png": 84160,
	"./NewDesign/start.png": 1593,
	"./NewDesign/stop.png": 73570,
	"./NewDesign/subtrip-end.png": 84756,
	"./NewDesign/subtrip-start.png": 70331,
	"./NewDesign/taxi-fill.png": 4371,
	"./NewDesign/taxi.png": 78363,
	"./NewDesign/ticket-fill.png": 35523,
	"./NewDesign/ticket-filled.png": 97797,
	"./NewDesign/ticket-icon.png": 4654,
	"./NewDesign/ticket.png": 4978,
	"./NewDesign/time-left.png": 48146,
	"./NewDesign/trash3-fill.png": 30305,
	"./NewDesign/trash3.png": 67241,
	"./NewDesign/up-arrow.png": 31535,
	"./NewDesign/vehiclelogs_icons.png": 98200,
	"./NewDesign/view.png": 26952,
	"./SchoolDashboard/ActiveBuses.png": 46751,
	"./SchoolDashboard/alert-bus-icon.png": 93332,
	"./SchoolDashboard/alert-icon.png": 53585,
	"./SchoolDashboard/calender-icon.png": 20124,
	"./Starling2logo.png": 10285,
	"./ac-icon-off.png": 46814,
	"./ac-icon-on.png": 2844,
	"./acceleration@2x.png": 65490,
	"./action-icon.png": 81064,
	"./alert-1@2x.png": 12692,
	"./alert-icon-green.png": 73781,
	"./alert-icon-red.png": 29316,
	"./alert-temperature-dashboard.png": 94678,
	"./app-gallery-btn.png": 91120,
	"./app-images/app-gallery-btn.png": 22249,
	"./app-images/app-store-btn.png": 14631,
	"./app-images/google-play-btn.png": 49854,
	"./app-store-btn.png": 96022,
	"./appStore.png": 60992,
	"./appstoreImg.png": 87524,
	"./arrow-angle-turning-to-right@2x.png": 91921,
	"./awtl-logo-login.png": 60993,
	"./awtl-logo.png": 58436,
	"./awtllaunchingdashboard/advance-dashboard.png": 87960,
	"./awtllaunchingdashboard/alerts.png": 38438,
	"./awtllaunchingdashboard/dashboard.png": 40194,
	"./awtllaunchingdashboard/detail-tracking.png": 29933,
	"./awtllaunchingdashboard/expiring-soon.png": 58855,
	"./awtllaunchingdashboard/help.png": 45574,
	"./awtllaunchingdashboard/history-tracking.png": 36645,
	"./awtllaunchingdashboard/live-tracking.png": 5266,
	"./awtllaunchingdashboard/logout.png": 29743,
	"./awtllaunchingdashboard/masters.png": 76561,
	"./awtllaunchingdashboard/mentainance-dashboard.png": 63881,
	"./awtllaunchingdashboard/reports.png": 6861,
	"./awtllaunchingdashboard/video-monitoring.png": 4720,
	"./awtllogo.png": 86038,
	"./battery-green.png": 78401,
	"./battery-red.png": 22540,
	"./bg-old.png": 42244,
	"./bg.png": 74145,
	"./break@2x.png": 33906,
	"./bus-icon-blue.png": 76618,
	"./bus-icon-green.png": 94506,
	"./bus-icon-red.png": 59772,
	"./bus-icon-yellow.png": 80249,
	"./bus-icon.png": 99602,
	"./calender-1@2x.png": 3216,
	"./camera.png": 80193,
	"./cancel-icon.png": 12605,
	"./cancel.png": 59685,
	"./cancelled@2x.png": 17950,
	"./car-icon-blue.png": 36798,
	"./car-icon-gray.png": 44984,
	"./car-icon-green.png": 8814,
	"./car-icon-red.png": 20545,
	"./car-icon-red1.png": 10158,
	"./car-icon-yellow.png": 90935,
	"./car-icon-yellow1.png": 85204,
	"./car-icon.png": 83176,
	"./car.png": 80941,
	"./carEvidence.png": 51933,
	"./chart.png": 64772,
	"./checkRouteLogo.png": 48239,
	"./clusterMarkers/1.png": 66296,
	"./clusterMarkers/10.png": 13833,
	"./clusterMarkers/11.png": 38605,
	"./clusterMarkers/12.png": 53706,
	"./clusterMarkers/13.png": 6971,
	"./clusterMarkers/14.png": 15731,
	"./clusterMarkers/15.png": 82604,
	"./clusterMarkers/2.png": 82061,
	"./clusterMarkers/3.png": 85046,
	"./clusterMarkers/4.png": 62538,
	"./clusterMarkers/5.png": 89815,
	"./clusterMarkers/6.png": 94783,
	"./clusterMarkers/7.png": 72043,
	"./clusterMarkers/8.png": 85482,
	"./clusterMarkers/9.png": 881,
	"./clusterMarkers/yellow.png": 30750,
	"./ctrax-inner.png": 9534,
	"./ctrax-login.png": 9545,
	"./dangerEvidence.png": 26031,
	"./data-processing.png": 85716,
	"./detailtracking/10Ton-PickUp-gray.png": 22316,
	"./detailtracking/10Ton-PickUp-green.png": 25722,
	"./detailtracking/10Ton-PickUp-red.png": 76651,
	"./detailtracking/10Ton-PickUp-yellow.png": 36354,
	"./detailtracking/2Ton-PickUp-gray.png": 47163,
	"./detailtracking/2Ton-PickUp-green.png": 30494,
	"./detailtracking/2Ton-PickUp-red.png": 11948,
	"./detailtracking/2Ton-PickUp-yellow.png": 28586,
	"./detailtracking/3Ton-PickUp-gray.png": 92630,
	"./detailtracking/3Ton-PickUp-green.png": 11453,
	"./detailtracking/3Ton-PickUp-red.png": 61252,
	"./detailtracking/3Ton-PickUp-yellow.png": 82081,
	"./detailtracking/5Ton-PickUp-gray.png": 38033,
	"./detailtracking/5Ton-PickUp-green.png": 77078,
	"./detailtracking/5Ton-PickUp-red.png": 86359,
	"./detailtracking/5Ton-PickUp-yellow.png": 62869,
	"./detailtracking/Ambulance-gray.png": 40895,
	"./detailtracking/Ambulance-green.png": 66406,
	"./detailtracking/Ambulance-red.png": 69122,
	"./detailtracking/Ambulance-yellow.png": 43245,
	"./detailtracking/Bobcat-gray.png": 90799,
	"./detailtracking/Bobcat-green.png": 56283,
	"./detailtracking/Bobcat-red.png": 22752,
	"./detailtracking/Bobcat-yellow.png": 91306,
	"./detailtracking/Boom-Loader-gray.png": 31343,
	"./detailtracking/Boom-Loader-green.png": 50543,
	"./detailtracking/Boom-Loader-red.png": 14101,
	"./detailtracking/Boom-Loader-yellow.png": 93871,
	"./detailtracking/Bulldozer-gray.png": 68570,
	"./detailtracking/Bulldozer-green.png": 7235,
	"./detailtracking/Bulldozer-red.png": 40479,
	"./detailtracking/Bulldozer-yellow.png": 17516,
	"./detailtracking/Canter-gray.png": 99670,
	"./detailtracking/Canter-green.png": 44959,
	"./detailtracking/Canter-red.png": 45260,
	"./detailtracking/Canter-yellow.png": 77360,
	"./detailtracking/Car-gray.png": 72113,
	"./detailtracking/Car-gray1.png": 18704,
	"./detailtracking/Car-gray2.png": 70290,
	"./detailtracking/Car-green.png": 55442,
	"./detailtracking/Car-green1.png": 92212,
	"./detailtracking/Car-green2.png": 31911,
	"./detailtracking/Car-grey.png": 54928,
	"./detailtracking/Car-red.png": 71330,
	"./detailtracking/Car-red1.png": 17337,
	"./detailtracking/Car-red2.png": 67737,
	"./detailtracking/Car-yellow.png": 18908,
	"./detailtracking/Car-yellow1.png": 78022,
	"./detailtracking/Car-yellow2.png": 23827,
	"./detailtracking/Coaster-Bus-gray.png": 33498,
	"./detailtracking/Coaster-Bus-green.png": 81136,
	"./detailtracking/Coaster-Bus-red.png": 21698,
	"./detailtracking/Coaster-Bus-yellow.png": 77186,
	"./detailtracking/Crane-gray.png": 95690,
	"./detailtracking/Crane-green.png": 14117,
	"./detailtracking/Crane-red.png": 30718,
	"./detailtracking/Crane-yellow.png": 17780,
	"./detailtracking/Dumper-gray copy.png": 57558,
	"./detailtracking/Dumper-gray.png": 15837,
	"./detailtracking/Dumper-green.png": 95730,
	"./detailtracking/Dumper-red.png": 46150,
	"./detailtracking/Dumper-yellow.png": 71749,
	"./detailtracking/Excavator-gray.png": 84038,
	"./detailtracking/Excavator-green.png": 81596,
	"./detailtracking/Excavator-red.png": 14002,
	"./detailtracking/Excavator-yellow.png": 58284,
	"./detailtracking/Forklif-gray.png": 4413,
	"./detailtracking/Forklif-green.png": 48481,
	"./detailtracking/Forklif-red.png": 56190,
	"./detailtracking/Forklif-yellow.png": 18431,
	"./detailtracking/Hiace-gray.png": 15175,
	"./detailtracking/Hiace-green.png": 10227,
	"./detailtracking/Hiace-red.png": 90867,
	"./detailtracking/Hiace-yellow.png": 39557,
	"./detailtracking/Hilux-gray.png": 23253,
	"./detailtracking/Hilux-green.png": 61541,
	"./detailtracking/Hilux-red.png": 68608,
	"./detailtracking/Hilux-yellow.png": 15880,
	"./detailtracking/JCB-gray.png": 33845,
	"./detailtracking/JCB-green.png": 39473,
	"./detailtracking/JCB-red.png": 59947,
	"./detailtracking/JCB-yellow.png": 80852,
	"./detailtracking/Mini-Bus-gray.png": 75841,
	"./detailtracking/Mini-Bus-green.png": 10362,
	"./detailtracking/Mini-Bus-red.png": 29657,
	"./detailtracking/Mini-Bus-yellow.png": 23802,
	"./detailtracking/Motorcycle-gray.png": 28497,
	"./detailtracking/Motorcycle-green.png": 83532,
	"./detailtracking/Motorcycle-red.png": 80838,
	"./detailtracking/Motorcycle-yellow.png": 48487,
	"./detailtracking/NewCarGray.png": 10891,
	"./detailtracking/NewCarGreen.png": 70996,
	"./detailtracking/NewCarRed.png": 15517,
	"./detailtracking/NewCarYellow.png": 79521,
	"./detailtracking/PickUp-gray.png": 94723,
	"./detailtracking/PickUp-green.png": 80923,
	"./detailtracking/PickUp-red.png": 76026,
	"./detailtracking/PickUp-yellow.png": 15613,
	"./detailtracking/Reefer-gray.png": 80963,
	"./detailtracking/Reefer-green.png": 94780,
	"./detailtracking/Reefer-red.png": 73063,
	"./detailtracking/Reefer-yellow.png": 90200,
	"./detailtracking/Roller-gray.png": 45959,
	"./detailtracking/Roller-green.png": 12079,
	"./detailtracking/Roller-red.png": 84140,
	"./detailtracking/Roller-yellow.png": 7945,
	"./detailtracking/SUV-gray.png": 40185,
	"./detailtracking/SUV-green.png": 22610,
	"./detailtracking/SUV-red.png": 28325,
	"./detailtracking/SUV-yellow.png": 27539,
	"./detailtracking/SchoolBus-gray.png": 93439,
	"./detailtracking/SchoolBus-green.png": 69760,
	"./detailtracking/SchoolBus-red.png": 5124,
	"./detailtracking/SchoolBus-yellow.png": 20598,
	"./detailtracking/Shovel-gray.png": 91585,
	"./detailtracking/Shovel-green.png": 24356,
	"./detailtracking/Shovel-red.png": 6032,
	"./detailtracking/Shovel-yellow.png": 78222,
	"./detailtracking/Smart Phone-gray.png": 89143,
	"./detailtracking/Sweeper-green.png": 28461,
	"./detailtracking/Sweeper-grey.png": 42262,
	"./detailtracking/Sweeper-red.png": 28488,
	"./detailtracking/Sweeper-yellow.png": 31571,
	"./detailtracking/Tanker-gray.png": 88928,
	"./detailtracking/Tanker-green.png": 82959,
	"./detailtracking/Tanker-red.png": 27992,
	"./detailtracking/Tanker-yellow.png": 51506,
	"./detailtracking/Tourist-Bus-gray.png": 52816,
	"./detailtracking/Tourist-Bus-green.png": 30651,
	"./detailtracking/Tourist-Bus-red.png": 15963,
	"./detailtracking/Tourist-Bus-yellow.png": 56795,
	"./detailtracking/Trailer-gray.png": 63897,
	"./detailtracking/Trailer-green.png": 63964,
	"./detailtracking/Trailer-red.png": 70143,
	"./detailtracking/Trailer-yellow.png": 89338,
	"./detailtracking/Truck-gray.png": 68865,
	"./detailtracking/Truck-green.png": 98882,
	"./detailtracking/Truck-red.png": 12655,
	"./detailtracking/Truck-yellow.png": 52399,
	"./detailtracking/Urvan-gray.png": 20332,
	"./detailtracking/Urvan-green.png": 66547,
	"./detailtracking/Urvan-red.png": 32034,
	"./detailtracking/Urvan-yellow.png": 92803,
	"./detailtracking/Van-gray.png": 53827,
	"./detailtracking/Van-green.png": 81035,
	"./detailtracking/Van-red.png": 49809,
	"./detailtracking/Van-yellow.png": 53453,
	"./detailtracking/alert-icon-green.png": 47957,
	"./detailtracking/alert-icon-red.png": 50503,
	"./detailtracking/battery-green-icon.png": 61950,
	"./detailtracking/battery-red-icon.png": 18230,
	"./detailtracking/car-icon-blue.png": 22975,
	"./detailtracking/default-gray.png": 10448,
	"./detailtracking/default-gray1.png": 11690,
	"./detailtracking/default-gray2.png": 60665,
	"./detailtracking/default-green.png": 85980,
	"./detailtracking/default-green1.png": 46962,
	"./detailtracking/default-green2.png": 14928,
	"./detailtracking/default-red.png": 53593,
	"./detailtracking/default-red1.png": 43709,
	"./detailtracking/default-red2.png": 18321,
	"./detailtracking/default-yellow.png": 60601,
	"./detailtracking/default-yellow1.png": 90237,
	"./detailtracking/default-yellow2.png": 33486,
	"./detailtracking/gps-icon-on-green.png": 20646,
	"./detailtracking/gps-icon-on-red.png": 94204,
	"./detailtracking/green-icon.png": 20297,
	"./detailtracking/ignition-icon-off-red.png": 11037,
	"./detailtracking/ignition-icon-off.png": 66597,
	"./detailtracking/ignition-icon-on.png": 99786,
	"./detailtracking/map-icon.png": 42121,
	"./detailtracking/red-icon.png": 30528,
	"./detailtracking/share-icon.png": 82219,
	"./detailtracking/yellow-icon.png": 82750,
	"./detailtracking_old/10Ton-gray-icon.png": 76287,
	"./detailtracking_old/10Ton-green-icon.png": 5978,
	"./detailtracking_old/10Ton-red-icon.png": 92170,
	"./detailtracking_old/10Ton-yellow-icon.png": 50242,
	"./detailtracking_old/3Ton-gray-icon.png": 77033,
	"./detailtracking_old/3Ton-green-icon.png": 10390,
	"./detailtracking_old/3Ton-red-icon.png": 87703,
	"./detailtracking_old/3Ton-yellow-icon.png": 14304,
	"./detailtracking_old/5Ton-gray-icon.png": 3521,
	"./detailtracking_old/5Ton-green-icon.png": 14608,
	"./detailtracking_old/5Ton-red-icon.png": 7603,
	"./detailtracking_old/5Ton-yellow-icon.png": 99350,
	"./detailtracking_old/Tourist-Bus-gray.png": 8805,
	"./detailtracking_old/Tourist-Bus-green.png": 84846,
	"./detailtracking_old/Tourist-Bus-red.png": 24065,
	"./detailtracking_old/Tourist-Bus-yellow.png": 9596,
	"./detailtracking_old/ac-icon-off.png": 7985,
	"./detailtracking_old/ac-icon-on.png": 28948,
	"./detailtracking_old/alert-icon-green.png": 71593,
	"./detailtracking_old/alert-icon-red.png": 12195,
	"./detailtracking_old/bobcat-roller-gray-icon.png": 38705,
	"./detailtracking_old/bobcat-roller-green-icon.png": 53426,
	"./detailtracking_old/bobcat-roller-red-icon.png": 30876,
	"./detailtracking_old/bobcat-roller-yellow-icon.png": 12517,
	"./detailtracking_old/boom-gray-icon.png": 82393,
	"./detailtracking_old/boom-green-icon.png": 91950,
	"./detailtracking_old/boom-red-icon.png": 26982,
	"./detailtracking_old/boom-yellow-icon.png": 67554,
	"./detailtracking_old/bulldozer-gray-icon.png": 51005,
	"./detailtracking_old/bulldozer-green-icon.png": 43186,
	"./detailtracking_old/bulldozer-red-icon.png": 1777,
	"./detailtracking_old/bulldozer-yellow-icon.png": 86060,
	"./detailtracking_old/bus-icon-blue.png": 98919,
	"./detailtracking_old/bus-icon-gray.png": 91239,
	"./detailtracking_old/bus-icon-green.png": 3676,
	"./detailtracking_old/bus-icon-red.png": 16174,
	"./detailtracking_old/bus-icon-yellow.png": 50071,
	"./detailtracking_old/canter-gray-icon.png": 53249,
	"./detailtracking_old/canter-green-icon.png": 64113,
	"./detailtracking_old/canter-red-icon.png": 37234,
	"./detailtracking_old/canter-yellow-icon.png": 56018,
	"./detailtracking_old/car-icon-blue.png": 64280,
	"./detailtracking_old/car-icon-gray.png": 25727,
	"./detailtracking_old/car-icon-green.png": 29057,
	"./detailtracking_old/car-icon-red.png": 85639,
	"./detailtracking_old/car-icon-yellow.png": 68318,
	"./detailtracking_old/crane-gray-icon.png": 44657,
	"./detailtracking_old/crane-green-icon.png": 2470,
	"./detailtracking_old/crane-red-icon.png": 82747,
	"./detailtracking_old/crane-yellow-icon.png": 7827,
	"./detailtracking_old/dumper-gray-icon.png": 15949,
	"./detailtracking_old/dumper-green-icon.png": 69099,
	"./detailtracking_old/dumper-red-icon.png": 92546,
	"./detailtracking_old/dumper-yellow-icon.png": 96676,
	"./detailtracking_old/excavator-gray-icon.png": 77728,
	"./detailtracking_old/excavator-green-icon.png": 74175,
	"./detailtracking_old/excavator-red-icon.png": 14329,
	"./detailtracking_old/excavator-yellow-icon.png": 9517,
	"./detailtracking_old/forklif-gray-icon.png": 98255,
	"./detailtracking_old/forklif-green-icon.png": 39213,
	"./detailtracking_old/forklif-red-icon.png": 31992,
	"./detailtracking_old/forklif-yellow-icon.png": 7277,
	"./detailtracking_old/gps-icon-off.png": 49892,
	"./detailtracking_old/gps-icon-on-green.png": 29078,
	"./detailtracking_old/gps-icon-on.png": 80967,
	"./detailtracking_old/hiace-gray-icon.png": 43165,
	"./detailtracking_old/hiace-green-icon.png": 95581,
	"./detailtracking_old/hiace-red-icon.png": 88897,
	"./detailtracking_old/hiace-yellow-icon.png": 89854,
	"./detailtracking_old/ignition-icon-off-red.png": 60045,
	"./detailtracking_old/ignition-icon-off.png": 10743,
	"./detailtracking_old/ignition-icon-on.png": 93786,
	"./detailtracking_old/jcb-gray-icon.png": 26563,
	"./detailtracking_old/jcb-green-icon.png": 25556,
	"./detailtracking_old/jcb-red-icon.png": 56799,
	"./detailtracking_old/jcb-yellow-icon.png": 71935,
	"./detailtracking_old/map-icon.png": 56192,
	"./detailtracking_old/mini-bus-gray-icon.png": 12659,
	"./detailtracking_old/mini-bus-green-icon.png": 51233,
	"./detailtracking_old/mini-bus-red-icon.png": 63863,
	"./detailtracking_old/mini-bus-yellow-icon.png": 72114,
	"./detailtracking_old/motorcycle-icon-gray.png": 21121,
	"./detailtracking_old/motorcycle-icon-green.png": 70035,
	"./detailtracking_old/motorcycle-icon-red.png": 82675,
	"./detailtracking_old/motorcycle-icon-yellow.png": 65839,
	"./detailtracking_old/pickup-icon-blue.png": 78077,
	"./detailtracking_old/pickup-icon-gray.png": 78564,
	"./detailtracking_old/pickup-icon-gray_old.png": 52605,
	"./detailtracking_old/pickup-icon-gray_old1.png": 79889,
	"./detailtracking_old/pickup-icon-green-old1.png": 73996,
	"./detailtracking_old/pickup-icon-green.png": 79824,
	"./detailtracking_old/pickup-icon-green_old.png": 59889,
	"./detailtracking_old/pickup-icon-red-old1.png": 8721,
	"./detailtracking_old/pickup-icon-red.png": 66333,
	"./detailtracking_old/pickup-icon-red_old.png": 88607,
	"./detailtracking_old/pickup-icon-yellow.png": 92791,
	"./detailtracking_old/pickup-icon-yellow_old.png": 94843,
	"./detailtracking_old/pickup-icon-yellow_old1.png": 58731,
	"./detailtracking_old/reefer-gray-icon.png": 8403,
	"./detailtracking_old/reefer-green-icon.png": 87775,
	"./detailtracking_old/reefer-red-icon.png": 5798,
	"./detailtracking_old/reefer-yellow-icon.png": 50405,
	"./detailtracking_old/roller-gray-icon.png": 82017,
	"./detailtracking_old/roller-green-icon.png": 91959,
	"./detailtracking_old/roller-red-icon.png": 85253,
	"./detailtracking_old/roller-yellow-icon.png": 75193,
	"./detailtracking_old/share-icon.png": 12928,
	"./detailtracking_old/shovel-gray-icon.png": 85402,
	"./detailtracking_old/shovel-green-icon.png": 33485,
	"./detailtracking_old/shovel-red-icon.png": 18900,
	"./detailtracking_old/shovel-yellow-icon.png": 44609,
	"./detailtracking_old/tanker-gray-icon.png": 46914,
	"./detailtracking_old/tanker-green-icon.png": 219,
	"./detailtracking_old/tanker-red-icon.png": 69561,
	"./detailtracking_old/tanker-yellow-icon.png": 70306,
	"./detailtracking_old/trailer-gray-icon.png": 32729,
	"./detailtracking_old/trailer-green-icon.png": 3112,
	"./detailtracking_old/trailer-red-icon.png": 79373,
	"./detailtracking_old/trailer-yellow-icon.png": 68355,
	"./detailtracking_old/truck-icon-blue.png": 15034,
	"./detailtracking_old/truck-icon-gray.png": 48692,
	"./detailtracking_old/truck-icon-green.png": 13810,
	"./detailtracking_old/truck-icon-red.png": 44107,
	"./detailtracking_old/truck-icon-yellow.png": 32973,
	"./detailtracking_old/urvan-gray-icon.png": 92260,
	"./detailtracking_old/urvan-green-icon.png": 83655,
	"./detailtracking_old/urvan-red-icon.png": 54285,
	"./detailtracking_old/urvan-yellow-icon.png": 22031,
	"./detailtracking_old/van-gray-icon.png": 18528,
	"./detailtracking_old/van-green-icon.png": 16164,
	"./detailtracking_old/van-red-icon.png": 49427,
	"./detailtracking_old/van-yellow-icon.png": 87490,
	"./double.png": 36026,
	"./download.png": 62177,
	"./drive7/drive7-login-logo.png": 97379,
	"./drive7/drive7-login-logo_back.png": 8336,
	"./drive7/loginBg.png": 80950,
	"./drive7DashboardLogo.png": 96290,
	"./drive7LogoBig.png": 41925,
	"./drive7LogoSmall.png": 71630,
	"./driverEvidence.png": 27949,
	"./eight.png": 33086,
	"./email.png": 90908,
	"./flag@2x.png": 77263,
	"./four.png": 63884,
	"./fuel@2x.png": 81508,
	"./garage.png": 86548,
	"./gateway.png": 56703,
	"./gbsLoginLogo.png": 96385,
	"./google-play-btn.png": 96843,
	"./gps-icon-off.png": 2716,
	"./gps-icon-on-green.png": 4012,
	"./gps-icon-on.png": 76534,
	"./highspeed-1@2x.png": 25568,
	"./hospital.png": 69944,
	"./humidity-green.png": 34060,
	"./humidity.png": 85133,
	"./icon/1.png": 89150,
	"./icon/10.png": 42488,
	"./icon/11.png": 59235,
	"./icon/2.png": 51612,
	"./icon/3.png": 45201,
	"./icon/4.png": 6456,
	"./icon/5.png": 84748,
	"./icon/6.png": 35943,
	"./icon/7.png": 34862,
	"./icon/8.png": 68725,
	"./icon/9.png": 84102,
	"./ignition-icon-off-red.png": 35672,
	"./ignition-icon-off.png": 64938,
	"./ignition-icon-on.png": 3410,
	"./inner-logo-starling.png": 49729,
	"./inner-logo.png": 31888,
	"./innerDashboard/circle.png": 860,
	"./innerDashboard/ellipse-455.png": 10763,
	"./innerDashboard/ellipse-456.png": 6558,
	"./innerDashboard/ellipse-457.png": 46138,
	"./innerDashboard/group-362@2x.png": 79405,
	"./innerDashboard/group-363@2x.png": 63030,
	"./innerDashboard/group-364@2x.png": 74712,
	"./innerDashboard/group-365@2x.png": 84694,
	"./innerDashboard/group-366@2x.png": 16335,
	"./innerDashboard/group-367@2x.png": 82990,
	"./innerDashboard/group-368@2x.png": 52355,
	"./innerDashboard/group-369@2x.png": 3343,
	"./innerDashboard/group-370@2x.png": 62408,
	"./innerDashboard/group-371@2x.png": 64696,
	"./innerDashboard/group-372@2x.png": 55624,
	"./innerDashboard/menu-logo.png": 294,
	"./insidemap-1@2x.png": 52796,
	"./intellicab_logo.png": 1455,
	"./list.png": 49378,
	"./livetracking/10Ton-PickUp-gray.png": 17778,
	"./livetracking/10Ton-PickUp-green.png": 39642,
	"./livetracking/10Ton-PickUp-red.png": 29473,
	"./livetracking/10Ton-PickUp-yellow.png": 53959,
	"./livetracking/2Ton-PickUp-gray.png": 92960,
	"./livetracking/2Ton-PickUp-green.png": 86279,
	"./livetracking/2Ton-PickUp-red.png": 88213,
	"./livetracking/2Ton-PickUp-yellow.png": 49429,
	"./livetracking/3Ton-PickUp-gray.png": 73478,
	"./livetracking/3Ton-PickUp-green.png": 65570,
	"./livetracking/3Ton-PickUp-red.png": 47555,
	"./livetracking/3Ton-PickUp-yellow.png": 50201,
	"./livetracking/5Ton-PickUp-gray.png": 66496,
	"./livetracking/5Ton-PickUp-green.png": 95217,
	"./livetracking/5Ton-PickUp-red.png": 14158,
	"./livetracking/5Ton-PickUp-yellow.png": 34036,
	"./livetracking/Ambulance-gray.png": 21446,
	"./livetracking/Ambulance-green.png": 57958,
	"./livetracking/Ambulance-red.png": 76730,
	"./livetracking/Ambulance-yellow.png": 38437,
	"./livetracking/Boom-Loader-gray.png": 74150,
	"./livetracking/Boom-Loader-green.png": 58177,
	"./livetracking/Boom-Loader-red.png": 18743,
	"./livetracking/Boom-Loader-yellow.png": 72449,
	"./livetracking/Bulldozer-gray.png": 33771,
	"./livetracking/Bulldozer-green.png": 90813,
	"./livetracking/Bulldozer-red.png": 72612,
	"./livetracking/Bulldozer-yellow.png": 80028,
	"./livetracking/Canter-gray.png": 81708,
	"./livetracking/Canter-green.png": 85299,
	"./livetracking/Canter-red.png": 7498,
	"./livetracking/Canter-yellow.png": 34880,
	"./livetracking/Car-gray.png": 32356,
	"./livetracking/Car-gray1.png": 26590,
	"./livetracking/Car-green.png": 57663,
	"./livetracking/Car-green1.png": 105,
	"./livetracking/Car-red.png": 62220,
	"./livetracking/Car-red1.png": 83493,
	"./livetracking/Car-yellow.png": 16002,
	"./livetracking/Car-yellow1.png": 65854,
	"./livetracking/Coaster-Bus-gray.png": 37798,
	"./livetracking/Coaster-Bus-green.png": 2847,
	"./livetracking/Coaster-Bus-red.png": 18026,
	"./livetracking/Coaster-Bus-yellow.png": 7091,
	"./livetracking/Crane-gray.png": 76966,
	"./livetracking/Crane-green.png": 13800,
	"./livetracking/Crane-red.png": 48612,
	"./livetracking/Crane-yellow.png": 13498,
	"./livetracking/Dumper-gray.png": 37026,
	"./livetracking/Dumper-green.png": 36965,
	"./livetracking/Dumper-red.png": 41374,
	"./livetracking/Dumper-yellow.png": 88364,
	"./livetracking/Excavator-gray.png": 88972,
	"./livetracking/Excavator-green.png": 88503,
	"./livetracking/Excavator-red.png": 8604,
	"./livetracking/Excavator-yellow.png": 26011,
	"./livetracking/Forklif-gray.png": 17806,
	"./livetracking/Forklif-green.png": 25209,
	"./livetracking/Forklif-red.png": 50047,
	"./livetracking/Forklif-yellow.png": 39913,
	"./livetracking/Hiace-gray.png": 2621,
	"./livetracking/Hiace-green.png": 8273,
	"./livetracking/Hiace-red.png": 58411,
	"./livetracking/Hiace-yellow.png": 59010,
	"./livetracking/Hilux-gray.png": 15849,
	"./livetracking/Hilux-green.png": 90508,
	"./livetracking/Hilux-red.png": 82723,
	"./livetracking/Hilux-yellow.png": 21106,
	"./livetracking/JCB-gray.png": 85340,
	"./livetracking/JCB-green.png": 17908,
	"./livetracking/JCB-red.png": 52299,
	"./livetracking/JCB-yellow.png": 45851,
	"./livetracking/Mini-Bus-gray.png": 83822,
	"./livetracking/Mini-Bus-green.png": 62325,
	"./livetracking/Mini-Bus-red.png": 26569,
	"./livetracking/Mini-Bus-yellow.png": 54385,
	"./livetracking/Motorcycle-gray.png": 72418,
	"./livetracking/Motorcycle-green.png": 88307,
	"./livetracking/Motorcycle-red.png": 98272,
	"./livetracking/Motorcycle-yellow.png": 15337,
	"./livetracking/PickUp-gray.png": 5184,
	"./livetracking/PickUp-green.png": 81352,
	"./livetracking/PickUp-red.png": 46022,
	"./livetracking/PickUp-yellow.png": 16343,
	"./livetracking/Roller-gray.png": 3300,
	"./livetracking/Roller-green.png": 64103,
	"./livetracking/Roller-red.png": 32029,
	"./livetracking/Roller-yellow.png": 75696,
	"./livetracking/SUV-gray.png": 88530,
	"./livetracking/SUV-green.png": 45484,
	"./livetracking/SUV-red.png": 4692,
	"./livetracking/SUV-yellow.png": 22719,
	"./livetracking/SchoolBus-gray.png": 61488,
	"./livetracking/SchoolBus-green.png": 34487,
	"./livetracking/SchoolBus-red.png": 90679,
	"./livetracking/SchoolBus-yellow.png": 14138,
	"./livetracking/Tanker-gray.png": 47445,
	"./livetracking/Tanker-green.png": 94121,
	"./livetracking/Tanker-red.png": 48442,
	"./livetracking/Tanker-yellow.png": 4218,
	"./livetracking/Tourist-Bus-gray.png": 84950,
	"./livetracking/Tourist-Bus-green.png": 92898,
	"./livetracking/Tourist-Bus-red.png": 24902,
	"./livetracking/Tourist-Bus-yellow.png": 3368,
	"./livetracking/Truck-gray.png": 58186,
	"./livetracking/Truck-green.png": 51762,
	"./livetracking/Truck-red.png": 42099,
	"./livetracking/Truck-yellow.png": 44651,
	"./livetracking/Urvan-gray.png": 62522,
	"./livetracking/Urvan-green.png": 34285,
	"./livetracking/Urvan-red.png": 30283,
	"./livetracking/Urvan-yellow.png": 26986,
	"./livetracking/Van-gray.png": 80898,
	"./livetracking/Van-green.png": 28987,
	"./livetracking/Van-red.png": 53507,
	"./livetracking/Van-yellow.png": 39461,
	"./livetracking/car-icon-blue.png": 41982,
	"./livetracking/default-gray.png": 46298,
	"./livetracking/default-gray1.png": 44781,
	"./livetracking/default-green.png": 78090,
	"./livetracking/default-green1.png": 66963,
	"./livetracking/default-red.png": 25600,
	"./livetracking/default-red1.png": 47759,
	"./livetracking/default-yellow.png": 85781,
	"./livetracking/default-yellow1.png": 6928,
	"./location-pin.png": 94646,
	"./locationLogo1.png": 76241,
	"./location_show.png": 5380,
	"./login-logo-W.png": 83554,
	"./login-logo-starling.png": 74597,
	"./login-logo.png": 14236,
	"./loginBg.png": 95322,
	"./logo-white.png": 36286,
	"./logo_icon.png": 52969,
	"./logout.png": 26919,
	"./map-car-icon-green.png": 68885,
	"./map-icon.png": 24626,
	"./map-image.png": 13052,
	"./map-lock-icon.png": 96855,
	"./mapIcon/gps_icon.png": 43250,
	"./meter.png": 64031,
	"./new_login_bg.png": 47383,
	"./nine.png": 40831,
	"./no-data.png": 76977,
	"./opt10.png": 41762,
	"./opt9.png": 14396,
	"./outsidemap-1@2x.png": 29869,
	"./overdue-2@2x.png": 41810,
	"./parking@2x.png": 71828,
	"./petrol.png": 56940,
	"./pickup-icon-blue.png": 86576,
	"./pickup-icon-gray.png": 23235,
	"./pickup-icon-green.png": 77977,
	"./pickup-icon-red.png": 27606,
	"./pickup-icon-yellow.png": 34184,
	"./pickup-icon.png": 36648,
	"./pin.png": 81441,
	"./play-icon.png": 80531,
	"./playStore.png": 45229,
	"./police.png": 64262,
	"./power-1@2x.png": 19592,
	"./processing-time.png": 55656,
	"./sendCmd/engine-off-icon.png": 46762,
	"./sendCmd/engine-on-icon.png": 94571,
	"./sendCmd/get-position-icon.png": 73877,
	"./sendCmd/lock-icon.png": 35418,
	"./sendCmd/unlock-icon.png": 56421,
	"./sensor_temp_dashboard.png": 51311,
	"./share-icon.png": 43105,
	"./signal-icon.png": 80748,
	"./single.png": 33854,
	"./sml-logo.png": 80433,
	"./starling-eye-small.png": 39809,
	"./starlingLogo1.png": 93512,
	"./starlinglogo.png": 9791,
	"./success.png": 83513,
	"./temprature_icon_temp_dashboard.png": 80903,
	"./thermometer-half-black.png": 53853,
	"./thermometer-half-green.png": 28670,
	"./thermometer-half.png": 56604,
	"./time-left@2x.png": 77447,
	"./trackeazy-logo.png": 89451,
	"./trackeazy-sml.png": 46046,
	"./trackeazyLogo.png": 65704,
	"./trip-copy.png": 67709,
	"./truck-icon-blue.png": 3458,
	"./truck-icon-gray.png": 46418,
	"./truck-icon-green.png": 89157,
	"./truck-icon-red.png": 27801,
	"./truck-icon-yellow.png": 16155,
	"./van-icon.png": 24718,
	"./van.png": 71276,
	"./vehicle-details1.png": 2265,
	"./vehicle-details2.png": 88044,
	"./vehicle-details3.png": 64650,
	"./vehicle-details4.png": 40384,
	"./vehicle-details5.png": 6316,
	"./vehicle-details6.png": 91487,
	"./vehicle-details7.png": 47188,
	"./vehicle-images/Bulldozer-green.png": 69601,
	"./vehicle-images/Bulldozer-grey.png": 38778,
	"./vehicle-images/Bulldozer-red.png": 28907,
	"./vehicle-images/Bulldozer-yellow.png": 35071,
	"./vehicle-images/Bus-green.png": 16902,
	"./vehicle-images/Bus-grey.png": 35831,
	"./vehicle-images/Bus-red.png": 5771,
	"./vehicle-images/Bus-yellow.png": 24283,
	"./vehicle-images/Car-green.png": 5116,
	"./vehicle-images/Car-grey.png": 60493,
	"./vehicle-images/Car-red.png": 41942,
	"./vehicle-images/Car-yellow.png": 80406,
	"./vehicle-images/Crane-green.png": 47114,
	"./vehicle-images/Crane-grey.png": 35531,
	"./vehicle-images/Crane-red.png": 45380,
	"./vehicle-images/Crane-yellow.png": 16072,
	"./vehicle-images/Loader-green.png": 42265,
	"./vehicle-images/Loader-grey.png": 44523,
	"./vehicle-images/Loader-red.png": 29946,
	"./vehicle-images/Loader-yellow.png": 32623,
	"./vehicle-images/Motorcycle-green.png": 18859,
	"./vehicle-images/Motorcycle-grey.png": 96396,
	"./vehicle-images/Motorcycle-red.png": 42713,
	"./vehicle-images/Motorcycle-yellow.png": 41285,
	"./vehicle-images/PickUp-green.png": 49536,
	"./vehicle-images/PickUp-grey.png": 85554,
	"./vehicle-images/PickUp-red.png": 19835,
	"./vehicle-images/PickUp-yellow.png": 62664,
	"./vehicle-images/Roller-green.png": 30133,
	"./vehicle-images/Roller-grey.png": 41777,
	"./vehicle-images/Roller-red.png": 96915,
	"./vehicle-images/Roller-yellow.png": 92229,
	"./vehicle-images/SUV-green.png": 77000,
	"./vehicle-images/SUV-grey.png": 95911,
	"./vehicle-images/SUV-red.png": 79245,
	"./vehicle-images/SUV-yellow.png": 5454,
	"./vehicle-images/Sweeper-green.png": 60499,
	"./vehicle-images/Sweeper-grey.png": 95028,
	"./vehicle-images/Sweeper-red.png": 88077,
	"./vehicle-images/Sweeper-yellow.png": 43356,
	"./vehicle-images/Tanker-green.png": 28549,
	"./vehicle-images/Tanker-grey.png": 51379,
	"./vehicle-images/Tanker-red.png": 13360,
	"./vehicle-images/Tanker-yellow.png": 74525,
	"./vehicle-images/Truck-gray.png": 49749,
	"./vehicle-images/Truck-green.png": 66272,
	"./vehicle-images/Truck-red.png": 95932,
	"./vehicle-images/Truck-yellow.png": 8011,
	"./vehicle-images/Van-green.png": 8461,
	"./vehicle-images/Van-grey.png": 1269,
	"./vehicle-images/Van-red.png": 39425,
	"./vehicle-images/Van-yellow.png": 28788,
	"./vehicle-images/Yatch-green.png": 48638,
	"./vehicle-images/Yatch-grey.png": 27843,
	"./vehicle-images/Yatch-red.png": 5545,
	"./vehicle-images/Yatch-yellow.png": 64858,
	"./vehicle-images/dumper-green.png": 44732,
	"./vehicle-images/dumper-grey.png": 45324,
	"./vehicle-images/dumper-red.png": 96657,
	"./vehicle-images/dumper-yellow.png": 88776,
	"./vehicle-images/forklift-green.png": 7224,
	"./vehicle-images/forklift-grey.png": 78776,
	"./vehicle-images/forklift-red.png": 28320,
	"./vehicle-images/forklift-yellow.png": 91338,
	"./vehicle-type-car.png": 84833,
	"./vehicle_temp_dashboard.png": 68909,
	"./video-monitoring-default.png": 92261,
	"./white-logo.png": 88990,
	"./zoom-icon copy.png": 31296,
	"./zoom-icon.png": 36260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;